import { FC, SVGProps } from 'react';

export const InfoIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6ZM4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16ZM15 11.1234C15 11.6756 15.4477 12.1234 16 12.1234H16.0122C16.5645 12.1234 17.0122 11.6756 17.0122 11.1234V11.1111C17.0122 10.5588 16.5645 10.1111 16.0122 10.1111H16C15.4477 10.1111 15 10.5588 15 11.1111V11.1234ZM17 20.9011C17 21.4534 16.5523 21.9011 16 21.9011C15.4477 21.9011 15 21.4534 15 20.9011V16.0122C15 15.4599 15.4477 15.0122 16 15.0122C16.5523 15.0122 17 15.4599 17 16.0122V20.9011Z"
			fill="currentColor"
		/>
	</svg>
);
